import get from "lodash/get";

export const extractStatusCode = (response)=>{
    let serviceResponseHeader = get(response,"serviceResponseHeader");
    return get(serviceResponseHeader,"statusCode");
}